export default "__VITE_ASSET__DL9q44cx__"